import { SidebarBrand } from "../root/layout/Sidebar";
import { EnterpriseCustomerOrganisationPicker } from "./EnterpriseCustomerOrganisationPicker";
import type { EnterpriseCustomer } from "./enterpriseCustomer";

type EnterpriseCustomerSidebarHeaderProps = { customer: EnterpriseCustomer };

export const EnterpriseCustomerSidebarHeader = ({ customer }: EnterpriseCustomerSidebarHeaderProps) => {
  return (
    <>
      <SidebarBrand height={12} sx={{ pt: "14px", pb: 0.5, pl: "19px", color: theme => theme.palette.ink["500"] }} />
      <EnterpriseCustomerOrganisationPicker customer={customer} />
    </>
  );
};
